// this is an autogenerated file from DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/EmailTemplateEditor/Content/From/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_EditAutomation_EventActions_Content_EventAction_Content_Content_Content_SendCommunication_EmailTemplateEditor_Content_From($location_uuid: uuid!) {
  comms_outbound_emails(order_by: { email: asc }) {
    id
    email
  }
  comms_defaults(
    where: { type: { _eq: "email" }, location_id: { _eq: $location_uuid } }
    limit: 1
  ) {
    id
    sender_id
  }
}

`